import { render, staticRenderFns } from "./observed_14.vue?vue&type=template&id=039f36d0&scoped=true&"
var script = {}
import style0 from "./observed_14.vue?vue&type=style&index=0&id=039f36d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f36d0",
  null
  
)

export default component.exports